import { UAParser } from "ua-parser-js";

export interface DeviceInfo {
  browser: string | null;
  browserVersion: string | null;
  os: string | null;
  osVersion: string | null;
  device: string | null;
  deviceType: string | null;
  deviceVendor: string | null;
}

export function parseUserAgent(userAgent: string): DeviceInfo {
  try {
    const parser = new UAParser(userAgent);
    const browserResult = parser.getBrowser();
    const osResult = parser.getOS();
    const deviceResult = parser.getDevice();

    return {
      browser: browserResult.name || null,
      browserVersion: browserResult.version || null,
      os: osResult.name || null,
      osVersion: osResult.version || null,
      device: deviceResult.model || null,
      deviceType: deviceResult.type || null,
      deviceVendor: deviceResult.vendor || null,
    };
  } catch (error) {
    console.error("Failed to parse user agent:", error);
    return {
      browser: null,
      browserVersion: null,
      os: null,
      osVersion: null,
      device: null,
      deviceType: null,
      deviceVendor: null,
    };
  }
}

export function getDeviceInfo(): DeviceInfo {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return {
      browser: null,
      browserVersion: null,
      os: null,
      osVersion: null,
      device: null,
      deviceType: null,
      deviceVendor: null,
    };
  }

  return parseUserAgent(navigator.userAgent);
}
